import { date } from '../../../lib/helpers';
import { headers, search, defaultItem, editedItem } from './attributes';


export default {
  data: () => ({
    options: {},
    dialog: false,
    editedIndex: -1,
    headers,
    defaultItem,
    search,
    editedItem,
    selectedRow: '',
  }),

  computed: {
    allData() {
      return this.$store.state.settingFee.settingSpeFee.allData;
    },
    totalData() {
      return this.$store.state.settingFee.settingSpeFee.totalData;
    },
    totalPage() {
      return this.$store.state.settingFee.settingSpeFee.totalPage;
    },
    loading() {
      return this.$store.state.settingFee.settingSpeFee.loading;
    },
    flashError: {
      get() {
        return this.$store.state.settingFee.settingSpeFee.flashError;
      },
      set() {
        this.$store.commit('settingFee/settingSpeFee/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.settingFee.settingSpeFee.flashErrorMessage;
    },
  },

  watch: {
    dialog(val) {
      if (!val) this.close();
    },
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },
    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    getData() {
      this.$store.commit('settingFee/settingSpeFee/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('settingFee/settingSpeFee/getData', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    editItem(item) {
      const newItem = { ...item, data: { id: item.id } };
      this.editedIndex =
        this.$store.state.settingFee.settingSpeFee.allData.indexOf(item);
      this.editedItem = { ...newItem };
      this.dialog = true;
    },

    clearSearch() {
      this.search.fee_name = '';
      this.search.fee_sharing = '';
      this.search.created_at = '';
      this.search.updated_at = '';
      this.search.start_month = '';
      this.search.start_year = '';
      this.$nextTick(() => {
        this.getData();
      });
    },
  },
};